const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DarkAges extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.DarkAges,
            "Each civilization with more than 4 science loses half of the surplus science (round up).",
            {}
        )
    }
}

module.exports = DarkAges;